import React, { Fragment } from 'react';

// Constants

import { TypeSwitch } from './HeaderIncludes';
import { headerConfig } from './configs/headerConfigs';
import { preventerTools } from '@utils/tools/preventerTools';


const Header = (props) => {
    const {
        environment,
        environment: {
            anonymous,
            language,
            links: {
                PHONE: phone
            },
            profile,
            stateCode,
            isStateFullStack,
            telexEnabled
        },
        showModal,
        changeLang,
        currentPath,
        errorStatus,
        ssapForm
    } = props;

    const {
        encryptedUserName
    } = preventerTools.provideObject(environment.user);

    const replacements = { phone, language, encryptedUserName };

    const headerProfileKey = profile ?? stateCode;

    const getComponent = () => {
        const navContent = headerProfileKey ? headerConfig[headerProfileKey](isStateFullStack) : [];
        const { linkDetails } = navContent;
        return linkDetails.map((details, index)=> {

            const { name } = details;
            const languageToSwitch = language && language === 'en' ? 'es' : 'en';

            if (details.visible === undefined || details.visible(environment, currentPath, telexEnabled, errorStatus)) {
                return (
                    <TypeSwitch key={name}
                        { ...{
                            details,
                            index,
                            environment,
                            anonymous,
                            stateCode: headerProfileKey,
                            replacements,
                            changeLang,
                            showModal,
                            languageToSwitch,
                            ssapForm
                        } }
                    />
                );
            }

        });
    };
    return (
        <Fragment>
            <ul className="usa-nav__primary usa-accordion main__nav__links-container">
                { getComponent() }
            </ul>
        </Fragment>
    );
};

export default Header;